const config = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  CLOUDINARY_UPLOAD_URL: process.env.REACT_APP_CLOUDINARY_UPLOAD_URL,
  CLOUDINARY_UPLOAD_PRESET: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET,
  GOOGLE_LOGIN: process.env.REACT_APP_LOGIN_GOOGLE,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
};

export default config;
